export enum smmTypes {
    FETCH_SMM_REQUEST = 'FETCH_SMM_REQUEST',
    FETCH_SMM_BY_ID_REQUEST = 'FETCH_SMM_BY_ID_REQUEST',
    EDIT_SMM = 'EDIT_SMM',
    CREATE_SMM = 'CREATE_SMM',
    DELETE_SMM = 'DELETE_SMM',
    SET_SMM = 'SET_SMM',
    SET_RELATIVE_SMM = 'SET_RELATIVE_SMM',
}
